import axios, { CancelTokenSource } from 'axios';
import { useContext, useRef } from 'react';
import useSWR from 'swr';
import { ListQuotesResponse } from '../api';
import {AXIOS_CANCEL_MSG, LogisticsReport, Page, QuoteFilter, SortDirection} from '../api/models';
import { ConfiguratorContext } from '../context';
import { ListQuotesResponseSort } from '../pages/quotes';
import {SortOrder, TablePaginationConfig} from "antd/lib/table/interface";
import {LogisticsFilter, LogisticsReportSort} from "../pages/logistics";


interface LogisticsListProps {
  current?: number
  pageSize?:number,
  filter:LogisticsFilter | undefined,
  sorter:LogisticsReportSort
}

const defaultSort = {
  columnKey: "readyToShip",
  order: 'ascend' as SortOrder
};

export const useLogistics = (props: LogisticsListProps) => {

  const cancelTokenSourceRef = useRef<CancelTokenSource>();
  const configurator = useContext(ConfiguratorContext);

  const fetcher = async ( props:LogisticsListProps  ) : Promise<Page<LogisticsReport> | undefined> => {

    const { filter, current, pageSize, sorter } = props;

    const sort = [sorter].flat().map( sorter => ({
      field: sorter.columnKey?.toString() || defaultSort.columnKey,
      direction: ( sorter.order === 'ascend' ? 'asc' : 'desc') as SortDirection,
    }));

    if ( cancelTokenSourceRef.current ) {
      cancelTokenSourceRef.current.cancel( AXIOS_CANCEL_MSG );
    }
    const cancelSource = axios.CancelToken.source();
    cancelTokenSourceRef.current = cancelSource;

    try {
      const resp = await configurator.api.fetchLogisticsReport({
            ...filter,
            page: (current || 1) - 1,
            size: pageSize || 20,
            sort,
          },
        cancelSource.token,
      )
      cancelTokenSourceRef.current = undefined;

      return resp.data;
    }
    catch(e: any) {
      const id = e.response?.data?.message || e.message ;
      if ( id === AXIOS_CANCEL_MSG ) return;
      throw e;
    }
  }

  // Use SWR for data fetching
  return useSWR([
    'fetchLogisticsReport',
    props
  ],
    ([_k, p]) => fetcher(p),
    {
      //maybe unnecessary
      revalidateOnFocus: false,
      //maybe unnecessary
      dedupingInterval:1 
    }
  );
};


export default useLogistics;

